import React, {useEffect, useState} from 'react';
import { Popover, Tooltip } from 'antd';
import { SettingOutlined } from '@ant-design/icons';
import './index.less';
import {useModel} from '@umijs/max';
import {customThemes, customThemesType} from "@/utils/commonDict";


interface ThemeSelectorProps {
  onThemeChange?: (theme: customThemesType) => void;
  size?: 'small' | 'medium' | 'large';
}


const ThemeSelector: React.FC<ThemeSelectorProps> = ({
                                                       onThemeChange,
                                                       size = 'medium'
                                                     }) => {

  const [visible, setVisible] = useState(false);
  const [currentTheme, setCurrentTheme] = useState({});
  const { initialState, setInitialState } = useModel('@@initialState');
  const updateThemeState = (newThemeCode: string) => {
    setInitialState((preState: any) => ({
      ...preState,
      theme: newThemeCode,
    }));
  };
  useEffect(() => {
    const localThemeCode = window.localStorage.getItem(`${initialState?.currentUser?.mobile}_edatlink_box_admin_theme`);
    let currentThemeTemp = customThemes?.find(item => item?.code === 'white');
    if (localThemeCode) {
      const theme = customThemes.find(item => item?.code === localThemeCode);
      if (theme) {
        currentThemeTemp = theme;
      }
    }
    if (currentThemeTemp) {
      requestAnimationFrame(() => {
        const body = document.body;
        const classList = Array.from(body.classList);
        Object.values(customThemes).forEach(t => {
          if (classList.includes(t.classname)) body.classList.remove(t.classname);
        });
        if (currentThemeTemp?.classname) body.classList.add(currentThemeTemp.classname);
      });
      setCurrentTheme(currentThemeTemp);
    }
  }, []);

  const handleThemeChange = (theme: customThemesType) => {
    if (window) {
      // 使用 requestAnimationFrame 确保在浏览器渲染周期内操作 DOM
      requestAnimationFrame(() => {
        const body = document.body;
        Object.values(customThemes).forEach(t => {
          if (t.classname) body.classList.remove(t.classname);
        });
        // 添加当前主题类
        if (theme.classname) body.classList.add(theme.classname);
      });
    }

    document.querySelector('body')?.classList?.add('__theme__default');

    if (initialState?.currentUser?.mobile && theme) {
      window.localStorage.setItem(`${initialState.currentUser.mobile}_edatlink_box_admin_theme`, theme?.code);
    }
    onThemeChange?.(theme);
    updateThemeState(theme.code);
    setCurrentTheme(theme);
  };

  const sizeStyles = {
    small: { width: 32, height: 32 },
    medium: { width: 40, height: 40 },
    large: { width: 48, height: 48 }
  };


  const content = (
    <div className="theme-selector-popover"  onMouseLeave={ ()=>  setVisible(false)}>
      <h4>选择主题</h4>
      <div className="theme-grid">
        {customThemes.map(theme => (
          <Popover key={theme.code} content={theme.name}>
            <div
              className={`theme-item ${currentTheme?.code === theme.code ? 'theme-item-active' : ''}`}
              onClick={() => handleThemeChange(theme)}
              style={{
                background: theme.colors.length > 1
                  ? `linear-gradient(135deg, ${theme.colors.join(', ')})`
                  : theme.colors[0]
              }}
            >
            </div>
          </Popover>
        ))}
      </div>
    </div>
  );

  return (
    <div
      className="theme-selector-container"
    >
      <Popover
        content={content}
        trigger="click"
        open={visible}
        onOpenChange={setVisible}
        placement="leftBottom"
      >
        <Popover content="主题设置">
          <div
            className="theme-trigger-button"
            style={sizeStyles[size]}
            onClick={() => setVisible(!visible)} // 手动控制显示/隐藏
          >
            <SettingOutlined />
          </div>
        </Popover>
      </Popover>
    </div>
  );
};

export default ThemeSelector;
